import { useMutation, useQueryClient } from "@tanstack/react-query";
import { rejectPublicationRequest } from "../api/publicationRequestsApi";

export function useRejectPublicationRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => rejectPublicationRequest(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["publication-requests"] }),
  });
}
